module.exports = __webpack_public_path__ + "f346a620760c522c7b0aef6c97fe9b52.woff";